import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import {
  FONT_CSS,
  FONT_STYLE,
} from "../../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  COMPONENTS,
  SPACING,
} from "../../../constants/design/spacing";
import { Button } from "../../Buttons/styles";

export const ExternalLinks = styled.div`
  display: flex;
  opacity: 0.64;

  > * {
    padding: ${SPACING.two}px;
    border-radius: ${BORDER_RADIUS.full}px;
    margin-right: ${SPACING.two}px;
    border: 1px solid ${COLORS.white.one};
  }
`;

export const VitalsSection = styled.div`
  margin-top: ${SPACING.five}px;
`;

export const LabelFlexWrapper = styled.div`
  display: flex;
`;

export const FormDisabledExplanationContainer = styled.div`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.two};
  padding: ${SPACING.two}px;
  margin-bottom: ${SPACING.three}px;
  background-color: ${LAYER_COLORS.two};
  border-radius: 4px;

  > div {
    ${FONT_CSS.label.two}
    color: ${COLORS.highlight.one};
    margin-bottom: ${SPACING.two}px;
  }

  strong {
    color: ${TEXT_COLORS.one};
  }
`;

export const MarginSelectorWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 100px 100px 56px;
  grid-gap: ${SPACING.two}px;
`;

export const LearnMoreText = styled.div.attrs(() => ({ role: "button" }))`
  transition: 0.2s all ease-in-out;
  cursor: pointer;

  &:hover {
    color: ${TEXT_COLORS.one};
  }

  height: 0px;
  opacity: 0;
  ${FONT_CSS.body.six}
  color: ${TEXT_COLORS.three};
`;

export const MarginButton = styled(Button)<{
  isSelected?: boolean;
}>`
  justify-content: flex-start;
  height: ${COMPONENTS.slider}px;
  padding: ${SPACING.two}px;
  text-align: left;

  &:disabled {
    opacity: 0.4;
  }

  > div {
    display: flex;
    flex-direction: column;
  }

  &:hover {
    ${LearnMoreText} {
      transition: 0.2s all ease-in-out;
      height: 12px;
      opacity: 1;
    }
  }

  ${({ isSelected }) =>
    isSelected
      ? css`
          color: ${TEXT_COLORS.one};
          box-shadow: 0px 0px 0px 1px ${TEXT_COLORS.one} inset;

          &:hover {
            box-shadow: 0px 0px 0px 1px ${TEXT_COLORS.one} inset;
          }
        `
      : css`
          color: ${TEXT_COLORS.three};
          box-shadow: 0px 0px 0px 1px ${BORDER_COLORS.one} inset;

          &:hover {
            box-shadow: 0px 0px 0px 1px ${BORDER_COLORS.one} inset;
          }
        `}
`;

export const MarginLabel = styled.div`
  ${FONT_STYLE.label.three};
  color: ${TEXT_COLORS.three};
`;

export const CoreRing = styled.div`
  border-radius: 50%;
  display: grid;
  align-self: center;
  margin: auto;
  width: 8px;
  height: 8px;
  background: ${COLORS.neutral.three};
  transition: 0.2s ease-in-out;
`;

export const InnerRing = styled.div<{ isIsolated?: boolean }>`
  border-radius: 50%;
  display: grid;
  align-self: center;
  margin: auto;
  width: 16px;
  height: 16px;
  transition: 0.2s ease-in-out;
  ${({ isIsolated }) =>
    isIsolated
      ? css`
          background: transparent !important;
        `
      : undefined};
`;

export const OuterRing = styled.div<{
  isSelected?: boolean;
}>`
  border-radius: 50%;
  display: grid;
  align-self: center;
  width: 24px;
  height: 24px;
  background: ${COLORS.neutral.six};
  transition: 0.2s ease-in-out;

  ${({ isSelected }) =>
    isSelected
      ? css`
          background: rgba(255, 255, 255, 0.15);

          ${InnerRing} {
            background: rgba(255, 255, 255, 0.25);
          }

          ${CoreRing} {
            background: ${TEXT_COLORS.one};
          }
        `
      : css`
          background: ${COLORS.neutral.four};

          ${InnerRing} {
            background: ${COLORS.neutral.three};
          }

          ${CoreRing} {
            background: ${COLORS.neutral.one};
          }
        `};
`;

export const LeverageInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
`;

export const LeverageDescription = styled.div`
  color: ${TEXT_COLORS.two};
  margin-bottom: ${SPACING.three}px;
  ${FONT_STYLE.label.one}
`;

export const LeverageLabel = styled.div`
  color: ${TEXT_COLORS.three};
  ${FONT_STYLE.label.three}
  margin-bottom: ${SPACING.one}px;
`;
